import {defineMessages} from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'features.pirBoxCard.cardTitle',
    defaultMessage: 'PIR Box',
    description: 'Title of PIR Box Card',
  },
  alternativeDepositTitle: {
    id: 'features.pirBoxCard.alternativeDepositTitle',
    defaultMessage: 'Deposito Alternative',
    description: 'Title of Alternative Deposit Item',
  },
  ordinaryDepositTitle: {
    id: 'features.pirBoxCard.ordinaryDepositTitle',
    defaultMessage: 'Deposito Ordinario',
    description: 'Title of Ordinary Deposit Item',
  },
  investableAmountLabel: {
    id: 'features.pirBoxCard.investableAmountLabel',
    defaultMessage: 'Importo Investibile',
    description: 'Label for investable amount',
  },
  netInvestedAmount: {
    id: 'features.pirBoxCard.netInvestedAmount',
    defaultMessage: 'Investito Netto',
    description: 'Label for net invested amount',
  },
  investableResidueLabel: {
    id: 'features.pirBoxCard.investableResidueLabel',
    defaultMessage: 'Residuo Investibile',
    description: 'Label for investable residue amount',
  },
  pirboxExpirationDateLabel: {
    id: 'features.pirBoxCard.pirboxExpirationDateLabel',
    defaultMessage: 'Data perdita beneficio fiscale',
    description: 'Label for pirbox expiration date',
  },
  graphButtonLabel: {
    id: 'features.pirBoxCard.graphButtonLabel',
    defaultMessage: 'Grafico',
    description: 'Label for show graphs button',
  },
  printButtonLabel: {
    id: 'features.pirBoxCard.printButtonLabel',
    defaultMessage: 'Scarica PDF',
    description: 'Label for print pdf button',
  },
  extrordinaryTaxationDisclaimerMessage: {
    id: 'features.pirBoxCard.extrordinaryTaxationDisclaimerMessage',
    defaultMessage: 'I dati sono calcolati escludendo i movimenti inerenti la tassazione straordinaria',
    description: 'disclaimer for extrordinary taxation',
  },
  partiteViaggiantiDisclaimerMessage: {
    id: 'features.pirBoxCard.extrordinaryTaxationDisclaimerMessage',
    defaultMessage: 'Il dato è calcolato escludendo i movimenti inerenti la tassazione straordinaria e al netto di eventuali partite viaggianti',
    description: 'disclaimer for partite viaggianti',
  },
  summaryTableTitle: {
    id: 'features.pirBoxCard.summaryTableTitle',
    defaultMessage: 'Tabella di riepilogo',
    description: 'title for summary table',
  },
  productDetailTableTitle: {
    id: 'features.pirBoxCard.productDetailTableTitle',
    defaultMessage: 'Dettaglio prodotto',
    description: 'title for detail table',
  },
  investmentPlan: {
    id: 'features.pirBoxCard.investmentPlan',
    defaultMessage: 'Piano di investimento',
    description: 'Piano di investimento',
  },
  composition: {
    id: 'features.pirBoxCard.composition',
    defaultMessage: 'Composizione',
    description: 'Composizione',
  },
  qualified: {
    id: 'features.pirBoxCard.qualified',
    defaultMessage: 'QUALIFICATO',
    description: 'QUALIFICATO',
  },
  notQualified: {
    id: 'features.pirBoxCard.notQualified',
    defaultMessage: 'NON QUALIFICATO',
    description: 'NON QUALIFICATO',
  },
  walletBackTextModal: {
    id: 'features.wallet.walletBackTextModal',
    defaultMessage: 'Indietro',
    description: 'Modal back text',
  },
});
